module.exports = __webpack_public_path__ + "static/media/louise-12.31dc0d6b.jpg";